import React, { useState, useEffect } from "react";

import { cl } from "../../utilities/cl";
import { getSortedObj } from "../../utilities/getSorted";

import MoreList from "../DraggableList/LoadMoreIndexNotDND";

import Button from "../Button";
import Track from "./Track";

import SvgArrowUpDown from "../SVG/ArrowUpDown";
import SvgWarning from "../SVG/Warning";
import SvgSelectAll from "../SVG/SelectAll";

import SvgClose from "../SVG/Close";
import { getNextSelected } from "../../utilities/getNextSelected";
import { isMobile } from "../../utilities/media";
import { saveTracksRef } from "../../store/Tracks/actions";
import { useDispatch } from "react-redux";
import {
  pauseTrack,
  playTrack,
  seekTrack,
  stopTrack,
} from "../../store/AudioPlayer/actions";
import { store } from "../../connect";

const Tracks = ({
  className = "",
  theme = false,
  tracks = [],
  searchFounded = [],
  showHideEndedButton = true,

  loading,
  searchActive,

  selected = [],
  toggleSelectedTrack,
  updateCurrentMark,
  loadTracks,
  toggleHideEnded: toggleHideEndedInner,
}) => {
  const tracksRef = React.useRef(null);
  const dispatch = useDispatch();

  const hPlay = (data) => {
    dispatch(playTrack(data));
  };
  const hPause = () => {
    dispatch(pauseTrack());
  };
  const hStop = () => {
    dispatch(stopTrack());
  };
  const hRewind = (time) => {
    time = store.getState().audio.duration * time;

    dispatch(seekTrack(time));
  };

  const [hideEnded, toggleHideEnded] = useState(true);

  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const sortTypes = {
    id: "number",
    name: "string",
  };

  const [trackPlaying, setTrackPlaying] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isWatching, setIsWatching] = useState(false);
  const [audio, setAudio] = useState(new Audio());
  const [lastClickedPlayId, setLastClickedPlayId] = useState(-1);

  useEffect(() => {
    if (typeof toggleHideEndedInner === "function")
      toggleHideEndedInner(hideEnded);
  }, [hideEnded]);

  useEffect(() => {
    loadTracks({ theme });
  }, []);

  useEffect(() => {
    if (!hideEnded) loadTracks({ outdate: "true" });
  }, [hideEnded]);

  useEffect(() => {
    if (lastClickedPlayId === trackPlaying) {
      audio.addEventListener("canplaythrough", audio.play);
    }
  }, [audio]);

  useEffect(() => {
    let stringTheme = "t";

    if (typeof theme === "boolean") {
      stringTheme = theme ? "tracks" : "theme";
    } else {
      stringTheme = theme;
    }

    dispatch(saveTracksRef({ tracksRef, theme: stringTheme }));
  }, [tracksRef, theme, tracks]);

  const toggleSelectedAll = () => {
    const ids = tracks.map((el) => el.id);

    toggleSelectedTrack({ ids, simple: true });
  };
  const toggleUnselectedAll = () => {
    toggleSelectedTrack({ ids: [], simple: true });
  };

  React.useImperativeHandle(tracksRef, () => ({ hStop, toggleSelectedAll }));

  const toggleSelected = (_, e) => {
    const target = e.target;
    const track = target.closest('.Track');
    
    if (!track || track.classList.contains("playing")) return;

    const trackId = Number(track.dataset.trackId);

    if (!isNaN(trackId)) {
      const newSelected = getNextSelected({
        multiple: true,
        items: tracks,
        itemId: trackId,
        selected: selected,
        ctrlKey: isMobile() || e.ctrlKey || e.metaKey,
        shiftKey: e.shiftKey,
      });

      toggleSelectedTrack({ ids: newSelected });
    }
  };

  className = cl(className, "Tracks", { "hide-ended": hideEnded });

  return (
    <section className={className}>
      <header className="Tracks__control">
        <div className="Tracks__grid">
          <div className="id">
            <Button
              type="string"
              onClick={() => toggleSort("id")}
              disabled={!tracks[0]}
            >
              <SvgArrowUpDown title="Сортировка по ID" />
              ID
            </Button>
          </div>
          <div className="play"></div>
          <div className="name">
            <Button
              type="string"
              onClick={() => toggleSort("name")}
              disabled={!tracks[0]}
            >
              <SvgArrowUpDown title="Сортировка по названию" />
              Название
            </Button>
          </div>

          {showHideEndedButton && (
            <div>
              <Button
                type="string"
                onClick={() => toggleHideEnded(!hideEnded)}
                disabled={!tracks[0]}
              >
                <SvgWarning
                  title={
                    hideEnded ? "Показать завершённые" : "Скрыть завершённые"
                  }
                />
                {hideEnded ? "Показать завершённые" : "Скрыть завершённые"}
              </Button>
            </div>
          )}
        </div>
      </header>
      <MoreList
        type="simple"
        placeholder="Список роликов пуст."
        loading={loading}
        scroll={{
          on: true,
          data: {
            variant: "white",
            size: "lg",
          },
        }}
        onClick={toggleSelected}
        content={{ items: getItems(), variant: "none" }}
        droppableId={`1`}
      />
    </section>
  );

  function getItems() {
    if (searchActive) tracks = searchFounded;
    if (hideEnded) {
      tracks = tracks.filter((track) => !track.clipEnded);
    }
    const sorted = getSortedObj(tracks, sortBy, sortTypes[sortBy], sortOrder);

    return sorted.map((track, index) => ({
      id: track.id,
      name: track.name,
      element: (
        <Track
          key={track.id}
          variant={index % 2 === 0 ? "gray" : ""}
          play={hPlay}
          pause={hPause}
          stop={hStop}
          rewind={hRewind}
          {...track}
        />
      ),
    }));
  }

  function toggleSort(by) {
    let order;

    if (sortBy === by) {
      order = sortOrder === "ASC" ? "DESC" : "ASC";
    } else {
      order = "ASC";
    }

    setSortOrder(order);
    setSortBy(by);
  }
};

export default Tracks;
